import { Link } from "react-router-dom";

type Props = {
  title: string;
  subtitle?: string;
  moreText?: string;
  morePath?: string;
};

export default function SectionHeading({ title, subtitle, moreText, morePath }: Props) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="min-w-0">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 flex items-center gap-2">
          <span className="w-1 h-6 rounded-full bg-accent-500 inline-block" />
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreText && morePath && (
        <Link
          to={morePath}
          className="shrink-0 text-sm text-foreground-600 hover:text-accent-600 transition-colors flex items-center gap-1 whitespace-nowrap"
        >
          {moreText}
          <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}